import React from 'react'
import Icon from '@ant-design/icons'
import ExternalLinkSvg from '../../assets/images/external-link.svg'

const ExternalLink = (props) => {
  return <Icon component={ExternalLinkSvg} {...props} />
}

export default ExternalLink